import { actionWithAppliedDate } from "../actionWithAppliedDate";

export const actionPrefix = "definition:";
const REPLACE_DEFINITIONS = `${actionPrefix}REPLACE_DEFINITIONS`;
const APPLY_VIEW_SETTINGS_TO_ALL_VIEWS = `${actionPrefix}APPLY_VIEW_SETTINGS_TO_ALL_VIEWS`;
const CHANGE_INCLUDE_NARRATIVE = `${actionPrefix}CHANGE_INCLUDE_NARRATIVE`;

export const actionTypes = {
  REPLACE_DEFINITIONS,
  APPLY_VIEW_SETTINGS_TO_ALL_VIEWS,
  CHANGE_INCLUDE_NARRATIVE
};

const replaceDefinitions = definitions => {
  return actionWithAppliedDate({
    type: REPLACE_DEFINITIONS,
    definitions
  });
};

const applyViewSettingsToAllViews = viewSettings => {
  return {
    type: APPLY_VIEW_SETTINGS_TO_ALL_VIEWS,
    viewSettings
  };
};

// So far, used for convert V2 in readonly mode
const changeIncludeNarrative = includeNarrative => {
  return {
    type: CHANGE_INCLUDE_NARRATIVE,
    includeNarrative
  };
};

export default {
  replaceDefinitions,
  applyViewSettingsToAllViews,
  changeIncludeNarrative
};
